/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import ReactModal from "react-modal";
import styles from "./styles.module.scss";
import { Loading } from "../../../../../../../components/Loading";
import { BrComerceApiService } from "../../../../../../../services/BrComerceApiService";
import Swal from "sweetalert2";
import { IoMdArrowRoundBack, IoIosClose } from "react-icons/io";
import { NoDelivery } from "./components/NotDelivery";
import { Delivery } from "./components/Delivery";
import { ownDeliveryNotDeliveredOptions } from "./utils/packageDeliveryStatus";
import Title from "../Title";
import { LuPackageCheck, LuPackageX } from "react-icons/lu";
import shippingStatus from "../../../../../../../enums/ShippingStagesEnum";

const stylesModal22 = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(51, 51, 51, 0.75)",
    zIndex: 999
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    zIndex: 999,
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    overflow: "visible"
  }
};

const menuNames = {
  default: "default",
  delivery: "delivery",
  noDelivery: "no-delivery",
}


export const EditPackageStatusModal = ({
  isOpen,
  handleCloseModal,
  shipping,
  refetch
}) => {
  const api = new BrComerceApiService();

  const [loading, setLoading] = React.useState(false)
  const [routeShippingData, setRouteShippingData] = React.useState()
  const [openMenu, setOpenMenu] = React.useState(menuNames.default)

  const [routeShippingOption, setRouteShippingOption] = React.useState()
  const [receiverData, setReceiverData] = React.useState()
  const [routeShippingError, setRouteShippingError] = React.useState()

  const [needEvidence, setNeedEvidence] = React.useState(false);
  const [evidenceError, setEvidenceError] = React.useState();
  const [evidenceImage, setEvidenceImage] = React.useState();

  async function handleSubmit() {
    let hasError = false
    const routeShippingStatusValue = routeShippingOption?.value
    const isNotDeliveryMenu = openMenu === menuNames.noDelivery

    if (!routeShippingStatusValue && isNotDeliveryMenu) {
      hasError = true
      setRouteShippingError("Campo obrigatório!")
    }

    // if (needEvidence && !evidenceImage && !isNotDeliveryMenu) {
    //   hasError = true
    //   setEvidenceError("É obrigatório vincular uma imagem!")
    // }

    if (hasError) {
      return
    }

    const routeShippingStatusId = routeShippingStatusValue

    try {
      let base64Image
      if (needEvidence && evidenceImage) {
        base64Image = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(evidenceImage);
          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.onerror = error => reject(error);
        });
      }

      setLoading(true)
      await api.makeHttpRequest({
        method: "PUT",
        url: `/route-shipping-admin/status/${routeShippingData.id}`,
        data: {
          statusId: routeShippingStatusId,
          addDelivery: shipping?.status?.id === shippingStatus.OBJETO_SAIU_PARA_ENTREGA.id,
          ...(!!receiverData && { receiverData }),
          ...(base64Image && { base64Image })
        }
      });
      Swal.fire({
        text: "Os status do objeto foram atualizados com sucesso.",
        title: "Sucesso!",
        icon: "success"
      });
    } catch (error) {
      const message = error?.response?.data?.message;

      Swal.fire({
        text: message ? message : "Falha ao atualizar status, tente novamente mais tarde.",
        title: message ? "Ocorreu um erro" : "Erro inesperado",
        icon: "error"
      });
    } finally {
      refetch()
      setLoading(false)
      handleCloseModal()
    }

  }

  function findOptionByValue(value, options) {
    return options.find(opt => opt?.value === value)
  }

  React.useEffect(() => {
    if (shipping) {
      async function getRouteShippingsByRouteId() {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: `route-shipping-admin/${shipping.id}`
        });

        if (response && response.length) {
          const routeShipping = response?.reduce((maxObj, currentObj) =>
            currentObj.id > maxObj.id ? currentObj : maxObj
          )
          if (routeShipping && routeShipping?.id_own_delivery_status) {
            setRouteShippingOption(findOptionByValue(routeShipping?.id_own_delivery_status, ownDeliveryNotDeliveredOptions))
            setRouteShippingData(routeShipping)
          }
        }

        setLoading(false)
      }
      try {
        setLoading(true)
        setNeedEvidence(!shipping?.deliveriesData?.length)
        getRouteShippingsByRouteId()
      } catch (e) {
        setLoading(false)
        console.log({ e });
      }
    }
  }, [])

  const onChangeRouteShippingOption = (e) => {
    setRouteShippingError()
    setRouteShippingOption(e)
  }

  if (loading) return <Loading loading={loading} />
  return (
    <>
      <ReactModal
        isOpen={isOpen}
        shouldCloseOnOverlayClick
        dialogClassName="schedule-pickup-modal"
        onRequestClose={handleCloseModal}
        style={stylesModal22}
        showCancelButton={true}
      >
        {routeShippingData && !loading
          ?
          (<div className={styles.container}>
            <div className={styles.closeButton}>
              <div>
                {(openMenu !== menuNames.default) && <IoMdArrowRoundBack onClick={() => setOpenMenu(menuNames.default)} />}
              </div>
              <button
                onClick={handleCloseModal}
              >
                <IoIosClose />
              </button>
            </div>

            {(openMenu === menuNames.delivery) && <Delivery
              handleSubmit={handleSubmit}
              handleBackButton={() => setOpenMenu(menuNames.default)}
              setReceiverData={setReceiverData}
              needEvidence={needEvidence}
              setEvidenceImage={setEvidenceImage}
              evidenceImage={evidenceImage}
              evidenceError={evidenceError}
              setEvidenceError={setEvidenceError}
            />}

            {(openMenu === menuNames.noDelivery) && <NoDelivery
              handleSubmit={handleSubmit}
              handleBackButton={() => setOpenMenu(menuNames.default)}
              onChange={onChangeRouteShippingOption}
              defaultValue={routeShippingOption}
              error={routeShippingError}
              options={ownDeliveryNotDeliveredOptions}
              needEvidence={needEvidence}
              setEvidenceImage={setEvidenceImage}
              evidenceImage={evidenceImage}
              evidenceError={evidenceError}
              setEvidenceError={setEvidenceError}
            />}

            {openMenu === menuNames.default && (<>
              <Title text={"Marcar objeto como:"} />
              <span>Altere o status do objeto entre entregue e não entregue.</span>
              <div className={styles.actionsContainer}>
                <button className={styles.deliveryButton} onClick={() => {
                  setRouteShippingOption({ label: "Entrega realizada", value: 11 })
                  setOpenMenu(menuNames.delivery)
                }}>
                  Marcar como entregue <LuPackageCheck size={24} />
                </button>

                <button className={styles.noDeliveryButton} onClick={() => {
                  setReceiverData()
                  setRouteShippingOption(findOptionByValue(routeShippingData?.id_own_delivery_status, ownDeliveryNotDeliveredOptions))
                  setOpenMenu(menuNames.noDelivery)
                }}>
                  Marcar como não entregue <LuPackageX size={24} />
                </button>
              </div>
            </>)}

          </div>)
          :
          <div className={styles.container} style={{ maxWidth: "260px" }}>
            <h2> O objeto não está associado a nenhuma rota! </h2>
          </div>}
      </ReactModal >
    </>
  );
};
